import { css } from 'styled-components';
/**
 * Limits the number of displayed text lines to a given maximum.
 */
export const lineClampCss = (maxLines) => css `
  box-orient: vertical;
  -webkit-box-orient: vertical;

  display: box;
  display: -webkit-box;

  line-clamp: ${maxLines};
  -webkit-line-clamp: ${maxLines};

  overflow: hidden;
  text-overflow: ellipsis;
`;
